module.exports = __webpack_public_path__ + "img/ic-thum-age-adult.7cb607ed.png";